import { useState } from 'react';
import Twitter from '../../../assets/img/twitter.svg';
import Facebook from '../../../assets/img/facebook.svg';
import Linkedin from '../../../assets/img/linkedin.svg';
import { getCurrentLanguage} from '../../../config'
import TermsAndConditions from '../../termsAndConditions/termsAndConditions';
import { t } from 'i18next';

export const Footer = () => {
	const selectedLang = getCurrentLanguage();
	const [showTerms, setShowTerms] = useState(false);

	const handleShowTerms = () => {
		console.log('show terms', showTerms);
		setShowTerms(true);
	};

	const handleCloseTerms = () => setShowTerms(false);	

	return (
		<div className='container-fliud marginHeaderAndFooter'>
			<div className='row footer'>
				<div className='col'>
					<p className='section'>Products</p>
					<a href="/events" style={{ textDecoration: 'none' }}><p className='content'>Events</p></a>
					<a href="/create-event" style={{ textDecoration: 'none' }}><p className='content'>Create</p></a>
				</div>
				<div className='col'>
					<p className='section'>Support</p>
					<p className='content'>About</p>
					<p className='content'>Contact Us</p>
					<p className='content' onClick={handleShowTerms}>{t('terms_and_conditions')}</p>
					<div className='col imgs'>
						<img src={Twitter} alt='Twitter' />
						<img src={Facebook} alt='Facebook' />
						<img className='m-0' src={Linkedin} alt='Linkedin' />
					</div>
				</div>
			</div>
			{showTerms && (
                <TermsAndConditions
                    showTerms={showTerms}
                    onClose={handleCloseTerms}
                />
            )}
		</div>
	);
}
